/* tslint:disable */
export enum PictureType {
  Profile = 1,
  LungScreening = 2,
  HealthRecord = 3,
}
